<template>
  <div class="course-card" v-if="course">
    <span class="course-card-total-time">{{ getCourseTime() }}</span>
    <div
      class="course-card-cover-photo"
      @click="goCourseDetail"
      :style="
        'background-image:url(' +
        (course && course.coverPhoto && course.coverPhoto.url) +
        ')'
      "
    ></div>
    <div class="course-card-content">
      <span
        class="course-card-title"
        :title="course.title"
        @click="goCourseDetail"
      >
        {{
          course.title.length > 20
            ? course.title.substring(0, 20) + "..."
            : course.title
        }}
        <span
          class="sign"
          v-if="course.auditState !== 4 && !audit"
          :style="{
            color: sign[course.auditState - 1].color,
            borderWidth: 1 + 'px',
            borderStyle: 'solid',
          }"
          >{{ sign[course.auditState - 1].content }}</span
        >
      </span>
      <div
        v-if="edit"
        class="course-card-footer"
        style="justify-content: flex-start"
      >
        <span
          class="course-card-tools"
          @click="editCourse"
          v-if="course.auditState !== 2"
          ><i class="user-edit"></i><span>编辑</span></span
        >
        <span
          class="course-card-tools"
          @click="deleteUserCourse"
          v-if="course.auditState !== 2"
          ><i class="user-delete"></i><span>删除</span></span
        >
        <span
          class="course-card-tools"
          @click="referUserCourse"
          v-if="course.auditState === 1"
          ><i class="user-submitaudit"></i><span>提交评审</span></span
        >
        <span
          class="course-card-tools"
          @click="noPastUserCourse"
          v-if="course.auditState === 2 && audit"
          ><i class="user-noreview"></i><span>未通过评审</span></span
        >
        <span
          class="course-card-tools"
          @click="pastUserCourse"
          v-if="course.auditState === 2 && audit"
          ><i class="user-finishreview"></i><span>通过评审</span></span
        >
      </div>
      <div v-else class="course-card-footer">
        <div>
          <span>{{ course.pageview }}人已学习</span>
          <span style="color: #999999; margin-left: 10px">{{
            course.updated_at && course.updated_at.day
          }}</span>
        </div>
        <div class="course-card-footer-like">
          <img :src="likeUrl" style="width: 20px; margin-right: 3px" />
          <span>{{ course.like }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import course from "@/assets/img/test/course.jpg";
import like from "@/assets/img/like.png";
export default {
  name: "course-card",
  data() {
    return {
      likeUrl: like,
      sign: [
        { content: "未过审", color: "#E70012" },
        { content: "审核中", color: "#FEB705" },
        { content: "草稿", color: "grey" },
      ],
    };
  },
  props: ["course", "edit", "uid", "audit"],
  methods: {
    ...mapActions("post", ["deletePost", "submitPost", "reasonPastPost"]),
    ...mapActions("userInfor", ["getUserPostList", "getUserAuditPosts"]),
    goCourseDetail() {
      const fieldid = this.course.fileGuid ? this.course.fileGuid : '35e5ba78-0623-4de0-9908-583d1546874c'
      window.open("https://iknow.kingdee.com/preview.html?fileid=" + fieldid + "&displayControl=32768");
    },
    getCourseTime() {
      if (!this.course || !this.course.totalTime) return "0:0";
      return (
        Math.floor(parseFloat(this.course.totalTime) / 60) +
        ":" +
        (Math.round(parseFloat(this.course.totalTime)) % 60)
      );
    },
    editCourse() {
      window.open("/upcourse/" + this.course._id);
    },
    deleteUserCourse() {
      this.$confirm(
        `此操作将永久删除课程${this.course.title}, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.deletePost(this.course._id);
          await this.getUserPostList(this.uid);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {});
    },
    referUserCourse() {
      this.$confirm(
        `此操作将提交审核课程 '${this.course.title}',是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.submitPost(this.course._id);
          await this.getUserAuditPosts();
          await this.getUserPostList(this.uid);
          this.$message({
            type: "success",
            message: "提交审核成功",
          });
        })
        .catch(() => {});
    },
    noPastUserCourse() {
      this.$confirm(
        `课程 '${this.course.title}' 未通过审核,是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await this.reasonPastPost({ postId: this.course._id, auditState: 1 });
          await this.getUserAuditPosts();
          await this.getUserPostList(this.uid);
          this.$message({
            type: "success",
            message: "提交成功",
          });
        })
        .catch(() => {});
    },
    pastUserCourse() {
      this.$confirm(`课程 '${this.course.title}' 通过审核,是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.reasonPastPost({ postId: this.course._id, auditState: 4 });
          await this.getUserAuditPosts();
          await this.getUserPostList(this.uid);
          this.$message({
            type: "success",
            message: "审核成功",
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.course-card {
  position: relative;
  width: 410px;
  height: 273px;
  box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center; //居中对齐弹性盒的各项 <div> 元素,元素位于容器的中心。
  flex-direction: column;
  > .course-card-total-time {
    position: absolute;
    top: 12px;
    left: 12px;
    padding: 0 13px;
    height: 23px;
    line-height: 23px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.3);
    color: #ffffff;
    font-size: 14px;
  }
  > .course-card-cover-photo {
    width: 410px;
    height: 184px;
    background-size: cover;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  > .course-card-content {
    width: 100%;
    height: 89px;
    border: 1px solid rgba(234, 234, 234, 1);
    border-top: none;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    > .course-card-title {
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      height: 21px;
      line-height: 21px;
      border-left: 4px solid rgba(231, 0, 18, 1);
      padding-left: 16px;
      text-align: left;
      .sign {
        display: inline-block;
        border-radius: 2px;
        height: 15px;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        margin-left: 12px;
        margin-bottom: 1px;
        padding: 0 6px;
        vertical-align: middle;
      }
    }
    > .course-card-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > .course-card-tools {
        display: flex;
        align-items: center;
        margin-right: 30px;
        > * {
          margin-right: 4px;
        }
        &:hover {
          cursor: pointer;
        }
        > .user-edit {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/img/useredit.png");
          background-size: cover;
        }
        > .user-delete {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/img/icon-delete.png");
          background-size: cover;
        }
        > .user-submitaudit {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/img/submitaduit.png");
          background-size: cover;
        }
        > .user-noreview {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/img/noreview.png");
          background-size: cover;
        }
        > .user-finishreview {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url("../../assets/img/finishreview.png");
          background-size: cover;
        }
      }
      > .course-card-footer-like {
        display: flex;
        align-items: center;
        font-weight: bold;
        color: #999999;
      }
    }
  }
}
</style>


